import type { VueConstructor } from 'vue';
import { getCurrentInstance as getVM } from 'vue';
import type { Store } from 'vuex';

type UseStore = <S>() => Store<S>
type CurrentVueInstance = InstanceType<VueConstructor>
type GetCurrentInstance = () => CurrentVueInstance

const getCurrentInstance: GetCurrentInstance = function () {
  const vm = getVM();
  if (!vm) throw new Error('This must be called within a setup function.');

  return vm.proxy;
};

export const useStore: UseStore = () => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error('"useStore" must be called within a setup function.');

  return vm.$store;
};
  